<template>
    <div class="container">
      <van-search placeholder="搜索网吧" v-model="value" @input="handleInputVlaue"/>
      <div class="search-list" v-for="(item,index) in SearchList" :key="index" @click="handleClickGoPage(item.id,item.siteName)">{{item.siteName}}</div>
    </div>
</template>

<script>
import { Search } from 'vant';
import { SearchList } from '@/api/inspection'
export default {
    components: {
        vanSearch:Search
    },
    data() {
        return {
            value:'',
            SearchList:[]
        }
    },
    mounted() {
        this.requestSearchList()
    },
    methods: {
        handleInputVlaue() {
            this.requestSearchList()
        },
        // 返回到填写检查单页面 
        handleClickGoPage(id,siteName) {
             this.$router.push({
                 path:'/writeinspectionrecords',
                 query:{
                     id:id,
                     siteName:siteName
                 }
             })
        },
        // 选择网吧列表
        requestSearchList() {
            let siteName = this.value
            SearchList({siteName:siteName}).then(res=>{
                 console.log(res)
                 this.SearchList = res.data
            })
        }
    }
}
</script>

<style scoped lang="scss">
  .container {
        width: 100%;
        height: 100%;
        background-color: #f6f6f6;
        overflow-x: hidden;
        .search-list {
            width: 100%;
            height: 50px;
            line-height: 50px;
            padding-left: 15px;
            box-sizing: border-box;
            background-color: #ffffff;
            text-align: left;
            font-size: 15px;
            border-bottom: 1px solid #f2f2f2;
        }
  }
</style>
